/* Theme-only decoration. Native Kaching selections, prices and cart submissions are retained. */
(() => {
 const giftImageUrl=document.currentScript?.dataset.giftImage;
 const giftIcon=giftImageUrl?'<img src="'+giftImageUrl+'" alt="Veridermis mystery gift box" width="64" height="64" loading="lazy" decoding="async">':'';
 const sync = () => {
  document.querySelectorAll('.product-info .kaching-bundles__bar').forEach(bar=>{
   const products=bar.querySelector('.kaching-bundles__bundle-products');
   const kit=bar.closest('kaching-bundle')?.dataset.bundleProduct==='true';
   if(!products&&!kit)return;
   const container=bar.querySelector('.kaching-bundles__bar-container');
   if(!container.querySelector('.vd-offer-badge')){const badge=document.createElement('span');badge.className='vd-offer-badge';badge.textContent='BUNDLE & SAVE';container.append(badge);}
   if(!container.querySelector('.vd-gift-preview')){const gift=document.createElement('div');gift.className='vd-gift-preview';gift.innerHTML=giftIcon+'<span><strong>FREE Mystery Gift</strong><small>Included with every bundle</small></span>';container.append(gift);}
  });
  document.querySelectorAll('.veri-purchase-bar__images').forEach(holder=>{
   const selected=document.querySelector('.product-info .kaching-bundles__bar:has(input[type="radio"]:checked)');
   const selectedImages=[...(selected?.querySelectorAll('.kaching-bundles__bundle-products__image')||[])].slice(0,2);
   const images=selectedImages.length?selectedImages.map(img=>({src:img.src,alt:img.closest('.kaching-bundles__bundle-products__product')?.querySelector('.kaching-bundles__bundle-products__title')?.textContent.trim()||''})):[{src:holder.dataset.defaultSrc,alt:holder.dataset.defaultAlt}];
   const key=JSON.stringify(images);
   if(holder.dataset.selection===key)return;
   holder.dataset.selection=key;
   holder.replaceChildren(...images.map(item=>{const img=document.createElement('img');img.src=item.src;img.alt=item.alt;img.width=56;img.height=62;return img;}));
  });
 };
 const start=()=>{
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
  const info=document.querySelector('.product-info');
  if(info)new MutationObserver(schedule).observe(info,{subtree:true,childList:true,attributes:true,characterData:true});
  document.addEventListener('change',schedule);
  document.addEventListener('variant:change',schedule);
  sync();
 };
 document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start();
})();
